import { render } from "./PartPlayerLanding.vue?vue&type=template&id=37aab965&scoped=true"
import script from "./PartPlayerLanding.vue?vue&type=script&lang=js"
export * from "./PartPlayerLanding.vue?vue&type=script&lang=js"

import "./PartPlayerLanding.vue?vue&type=style&index=0&id=37aab965&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37aab965"]])

export default __exports__